import type { JiraIntentDetectionQueryVariables } from './types';

/**
 * Helper function to create consistent cache keys.
 */
export const createCacheKey: (variables: JiraIntentDetectionQueryVariables) => string = (
	variables: JiraIntentDetectionQueryVariables,
): string => {
	const { siteId, orgId, query, experience, model, includePatternType } = variables;
	const parts = [siteId, orgId, query, experience];
	if (model) {
		parts.push(model);
	}
	parts.push(`includePatternType=${includePatternType}`);
	return parts.join(':');
};
